module.exports = __webpack_public_path__ + "static/media/team-a.9219a765.jpg";